
export default function moduleDelete (context) {
  const {resource, $name, $namespace, $parentNamespace} = context;
  const uc = resource.name.toUpperCase();
  const DELETE_RESET = uc + '_DELETE_RESET'
  const DELETE_SET_ERROR = uc + '_DELETE_SET_ERROR'
  const DELETE_SET_DELETED = uc + '_DELETE_SET_DELETED'
  const DELETE_TOGGLE_LOADING = uc + '_DELETE_TOGGLE_LOADING'

  return {
    namespaced: true,
    state: {
      $name,
      $namespace,
      $parentNamespace,
      isLoading: false,
      error: '',
      deleted: null
    },
    actions: {
      del: ({ commit, dispatch }, item) => {
        commit(DELETE_TOGGLE_LOADING)

        return dispatch('api/delete', {uri: item['@id']}, { root: true })
          .then(() => {
            commit(DELETE_TOGGLE_LOADING)
            commit(DELETE_SET_DELETED, item)
          })
          .catch((e) => {
            commit(DELETE_TOGGLE_LOADING)
            commit(DELETE_SET_ERROR, e.message)
          })
      },
      reset: ({ commit }) => {
        commit(DELETE_RESET)
      }
    },
    getters: {
      deleted: state => state.deleted,
      error: state => state.error,
      isLoading: state => state.isLoading
    },
    mutations: {
      [DELETE_SET_DELETED] (state, deleted) {
        Object.assign(state, {deleted})
      },
      [DELETE_SET_ERROR] (state, error) {
        Object.assign(state, {error})
      },
      [DELETE_TOGGLE_LOADING] (state) {
        Object.assign(state, {isLoading: !state.isLoading})
      },
      [DELETE_RESET] (state) {
        Object.assign(state, {
          deleted: null,
          error: '',
          isLoading: false
        })
      }
    }
  }
}
